import { render, staticRenderFns } from "./PrintingCustomerTraffic.vue?vue&type=template&id=355ac2b4&scoped=true"
import script from "./PrintingCustomerTraffic.vue?vue&type=script&lang=js"
export * from "./PrintingCustomerTraffic.vue?vue&type=script&lang=js"
import style0 from "./PrintingCustomerTraffic.vue?vue&type=style&index=0&id=355ac2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ac2b4",
  null
  
)

export default component.exports